/**
 * Generate WhatsApp share URL with property details
 * @param {Object} property - Property object with details
 * @param {string} phoneNumber - WhatsApp Business number (optional)
 * @returns {string} WhatsApp share URL
 */
export const generateWhatsAppShareUrl = (property, phoneNumber = '') => {
  if (!property) return '';

  // Format the message with property details
  const message = `🏠 *${property?.address || 'عقار متميز'}*\n\n` +
    `📍 *الموقع:* ${property?.district || 'غير محدد'}\n` +
    `🏢 *النوع:* ${property?.type || 'غير محدد'}\n` +
    `🏘️ *نوع العقار:* ${property?.realEstateType || 'غير محدد'}\n` +
    `💰 *السعر:* ${formatCurrency(property?.price, property?.currency)}\n` +
    `📊 *الحالة:* ${property?.status || 'غير محدد'}\n` +
    `🆔 *معرف العقار:* ${property?.propertyId || 'غير محدد'}\n\n` +
    (property?.remarks ? `📝 *ملاحظات:* ${property?.remarks}\n\n` : '') +
    (property?.lat && property?.lng ? 
      `📌 *الموقع على الخريطة:*\nhttps://www.google.com/maps?q=${property?.lat},${property?.lng}\n\n` : 
      '') +
    (property?.image ? `🖼️ *صورة العقار:*\n${property?.image}\n\n` : '') +
    (property?.videos && property?.videos?.length > 0 ? 
      `🎥 *فيديوهات العقار:*\n${property?.videos?.map((v, i) => `${i + 1}. ${v?.url || v}`)?.join('\n')}\n\n` : 
      '') +
    `---\n` +
    `ARDD Real Estate | عقارات ARDD`;

  // Encode the message for URL
  const encodedMessage = encodeURIComponent(message);

  // If phone number provided, use it; otherwise, just the message
  if (phoneNumber) {
    // Remove any non-numeric characters except +
    const cleanPhone = phoneNumber?.replace(/[^0-9+]/g, '');
    return `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
  }

  // For sharing without specific number (opens WhatsApp with message ready)
  return `https://api.whatsapp.com/send?text=${encodedMessage}`;
};

/**
 * Format currency for display
 */
const formatCurrency = (amount, currency) => {
  if (!amount) return 'غير محدد';
  const formatted = new Intl.NumberFormat('ar-EG')?.format(amount);
  return `${formatted} ${currency || ''}`;
};

/**
 * Open WhatsApp share dialog
 * @param {Object} property - Property object
 * @param {string} phoneNumber - Optional phone number
 */
export const sharePropertyViaWhatsApp = (property, phoneNumber = '') => {
  const url = generateWhatsAppShareUrl(property, phoneNumber);
  if (url) {
    window.open(url, '_blank');
  }
};

export default { generateWhatsAppShareUrl, sharePropertyViaWhatsApp };